'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseRuntime, platform;

platform = require('../helpers/platform');

BaseRuntime = function (_platform$EventEmitte) {
  _inherits(BaseRuntime, _platform$EventEmitte);

  function BaseRuntime(definition) {
    _classCallCheck(this, BaseRuntime);

    var _this = _possibleConstructorReturn(this, (BaseRuntime.__proto__ || Object.getPrototypeOf(BaseRuntime)).call(this));

    _this.definition = definition;
    if (!_this.definition.capabilities) {
      _this.definition.capabilities = [];
    }
    _this.graph = null;
    return _this;
  }

  _createClass(BaseRuntime, [{
    key: 'setMain',
    value: function setMain(graph) {
      this.graph = graph;
    }
  }, {
    key: 'getType',
    value: function getType() {
      return this.definition.protocol;
    }
  }, {
    key: 'getAddress',
    value: function getAddress() {
      return this.definition.address;
    }
  }, {
    key: 'canDo',
    value: function canDo(capability) {
      return this.definition.capabilities.indexOf(capability) !== -1;
    }
  }, {
    key: 'isConnected',
    value: function isConnected() {
      return false;
    }

    // Connect to the target runtime environment (iframe URL, WebSocket address)

  }, {
    key: 'connect',
    value: function connect() {}
  }, {
    key: 'disconnect',
    value: function disconnect() {}
  }, {
    key: 'reconnect',
    value: function reconnect() {
      this.disconnect();
      return this.connect();
    }

    // Start a NoFlo Network

  }, {
    key: 'start',
    value: function start() {
      if (!this.graph) {
        throw new Error('No graph defined for execution');
      }
      return this.sendNetwork('start', {
        graph: this.graph.name || this.graph.properties.id
      });
    }

    // Stop a NoFlo network

  }, {
    key: 'stop',
    value: function stop() {
      if (!this.graph) {
        throw new Error('No graph defined for execution');
      }
      return this.sendNetwork('stop', {
        graph: this.graph.name || this.graph.properties.id
      });
    }

    // Set the parent element that some runtime types need

  }, {
    key: 'setParentElement',
    value: function setParentElement(parent) {}

    // Get a DOM element rendered by the runtime for preview purposes

  }, {
    key: 'getElement',
    value: function getElement() {}
  }, {
    key: 'recvMessage',
    value: function recvMessage(message) {
      this.emit('message', message);
      switch (message.protocol) {
        case 'runtime':
          return this.recvRuntime(message.command, message.payload);
        case 'graph':
          return this.recvGraph(message.command, message.payload);
        case 'network':
          return this.recvNetwork(message.command, message.payload);
        case 'component':
          return this.recvComponent(message.command, message.payload);
        case 'trace':
          return this.recvTrace(message.command, message.payload);
      }
    }
  }, {
    key: 'recvRuntime',
    value: function recvRuntime(command, payload) {
      var key, val;
      if (command === 'runtime') {
        for (key in payload) {
          val = payload[key];
          this.definition[key] = val;
        }
        this.emit('capabilities', payload.capabilities || []);
      }
      return this.emit('runtime', {
        command: command,
        payload: payload
      });
    }
  }, {
    key: 'recvComponent',
    value: function recvComponent(command, payload) {
      switch (command) {
        case 'error':
          return this.emit('network', {
            command: command,
            payload: payload
          });
        default:
          return this.emit('component', {
            command: command,
            payload: payload
          });
      }
    }
  }, {
    key: 'recvGraph',
    value: function recvGraph(command, payload) {
      return this.emit('graph', {
        command: command,
        payload: payload
      });
    }
  }, {
    key: 'recvNetwork',
    value: function recvNetwork(command, payload) {
      switch (command) {
        case 'started':
          return this.emit('execution', {
            running: payload != null && payload.running != null ? payload.running : true,
            started: payload != null && payload.started ? payload.started : true
          });
        case 'stopped':
          return this.emit('execution', {
            running: payload != null && payload.running != null ? payload.running : false,
            started: payload != null && payload.started ? payload.started : false
          });
        case 'status':
          return this.emit('execution', {
            running: payload.running,
            started: payload.started
          });
        case 'icon':
          return this.emit('icon', payload);
        default:
          return this.emit('network', {
            command: command,
            payload: payload
          });
      }
    }
  }, {
    key: 'recvTrace',
    value: function recvTrace(command, payload) {
      return this.emit('trace', {
        command: command,
        payload: payload
      });
    }
  }, {
    key: 'sendRuntime',
    value: function sendRuntime(command) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      payload.secret = this.definition.secret;
      return this.send('runtime', command, payload);
    }
  }, {
    key: 'sendGraph',
    value: function sendGraph(command) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      payload.secret = this.definition.secret;
      return this.send('graph', command, payload);
    }
  }, {
    key: 'sendNetwork',
    value: function sendNetwork(command) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      payload.secret = this.definition.secret;
      return this.send('network', command, payload);
    }
  }, {
    key: 'sendComponent',
    value: function sendComponent(command) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      payload.secret = this.definition.secret;
      return this.send('component', command, payload);
    }
  }, {
    key: 'sendTrace',
    value: function sendTrace(command) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      payload.secret = this.definition.secret;
      return this.send('trace', command, payload);
    }
  }, {
    key: 'send',
    value: function send(protocol, command, payload) {}
  }]);

  return BaseRuntime;
}(platform.EventEmitter);

module.exports = BaseRuntime;